import React from "react";

import logo from "../assets/logo.svg";

import { returnTextByOrg } from "../utils/textHelpers";

const Hero = () => {
  const hostname = window.location.hostname;
  const splithostname = hostname.split(".");
  let subdomain = splithostname[0];
  let organization,
    connection = "";
  if (
    splithostname.length > 3 ||
    (splithostname.length > 1 && splithostname[1].includes("localhost"))
  ) {
    organization = connection = subdomain;
  }

  return (
    <>
      <style>
        {`
        .hero {
          ${returnTextByOrg(organization, {
            southcentralpower: "color:white;",
            austinutilities: "color:white;",
            oec: "color:white;",
            nisc: "color:white;",
          })}
          // background-color: #fff;
        }
          .content-title {
            ${returnTextByOrg(organization, {
              southcentralpower: "color:#d87e3f;",
              austinutilities: "color:#d9dbc4;",
              oec: "color:#3a9776;",
              nisc: "color:#89343c;",
            })}
          }
      `}
      </style>
      <div className="text-center hero my-5 hero">
        {/* <img className="mb-3 app-logo" src={logo} alt="React logo" width="120" /> */}
        <h1 className="content-title" style={{ fontSize: "35px" }}>
          {returnTextByOrg(organization, {
            southcentralpower: "Making membership even easier",
            austinutilities:
              "Your City of Austin Utility Departments & Services",
            oec: "Your Trusted Energy Advisor",
            nisc: "About NISC",
          })}
        </h1>
        {returnTextByOrg(organization, {
          southcentralpower: (
            <div
              style={{
                height: "4px",
                backgroundColor: "#fcc424",
                margin: "15px",
              }}
            />
          ),
          austinutilities: (
            <div
              style={{
                height: "4px",
                backgroundColor: "#2e6598",
                margin: "15px",
              }}
            />
          ),
          oec: (
            <div
              style={{
                height: "4px",
                backgroundColor: "#0f4a38",
                margin: "15px",
              }}
            />
          ),
          nisc: (
            <div
              style={{
                height: "4px",
                backgroundColor: "#ac3242",
                margin: "15px",
              }}
            />
          ),
        })}

        <p className="lead" style={{ fontSize: "25px" }}>
          {returnTextByOrg(organization, {
            southcentralpower: `We’re making changes and enhancements that make it easier to be a member and keeping up with bills and payments every month.
Check out these easy ways to pay.`,
            austinutilities:
              "Doing our part to make Austin a great place to live and work.",
            oec: "OEC’s mission is to improve our members’ quality of life through the services we offer. From providing highly reliable electric service to supporting our community through programs like Operation Round Up, we strive to equip our members with the tools they need to live a safe, energy-efficient life.",
            nisc: `National Information Solutions Cooperative (NISC) is an information
          technology company that develops and supports software and hardware
          solutions for our Member-Owners across the nation. NISC is an industry
          leader providing advanced, integrated IT solutions for consumer and
          subscriber billing, accounting, engineering & operations, as well as
          many other leading-edge IT solutions. At NISC, our focus is service
          excellence and innovative information technology solutions that enable
          our Member-Owners to excel in customer service, maximize
          diversification opportunities, and compete effectively in the changing
          utility and broadband industries.`,
          })}
        </p>
      </div>
    </>
  );
};
export default Hero;
